import { SET_PAST_ORDERS, SET_PRESENT_ORDERS } from "../actions/ordersAction";
import { SET_PRESENT_ORDER_NUM } from "../types";
const initialState = {
  presentOrders: [],
  pastOrders: [],
  presentOrdersNum: null,
};

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRESENT_ORDERS:
      return {
        ...state,
        presentOrders: action.payload,
      };
    case SET_PAST_ORDERS:
      return {
        ...state,
        pastOrders: action.payload,
      };
    case SET_PRESENT_ORDER_NUM:
      return {
        ...state,
        presentOrdersNum: action.payload,
      };
    default:
      return state;
  }
};

export default ordersReducer;
